import { render, staticRenderFns } from "./socsosubNew.vue?vue&type=template&id=795d11c6"
import script from "./socsosubNew.vue?vue&type=script&lang=js"
export * from "./socsosubNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports